// extracted by mini-css-extract-plugin
var _1 = "ProfileContactsWidgetListCellButton-moduleProfileContactsWidgetListCellButton__GZYs1";
export { _1 as "ProfileContactsWidgetListCellButton" }
